(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nav-menu"] && !Shopify.designMode) return;
  try {
    class NavMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.behavior !== 'click') return;

      this.addEventListener('click', this.#onClick);
      this.addEventListener('keydown', this.#onKeydown);
      document.addEventListener('click', this.#onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onDocumentClick);
    }

    #onClick = (event) => {
      const toggle = event.target.closest('.nav-menu__toggle');
      if (!toggle) return;

      const item = toggle.closest('.nav-menu__item');
      const wasOpen = item.hasAttribute('data-open');

      this.#closeAll();

      if (!wasOpen) {
        item.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    };

    #onKeydown = (event) => {
      if (event.key !== 'Escape') return;

      const openToggle = this.querySelector('.nav-menu__item[data-open] .nav-menu__toggle');
      this.#closeAll();
      openToggle?.focus();
    };

    #onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.#closeAll();
    };

    #closeAll() {
      for (const item of this.querySelectorAll('.nav-menu__item[data-open]')) {
        item.removeAttribute('data-open');
        item.querySelector('.nav-menu__toggle')?.setAttribute('aria-expanded', 'false');
      }
    }
  }

  if (!customElements.get('nav-menu')) {
    customElements.define('nav-menu', NavMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-measurements')) {
    customElements.define(
      'size-measurements',
      class extends HTMLElement {
        connectedCallback() {
          this.data = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '[]');
          this.addEventListener('change', this.onChange);
        }

        onChange = (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement)) return;

          const picker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
          const match = picker?.querySelector(
            `input[data-option-name="${CSS.escape(input.dataset.optionName)}"][value="${CSS.escape(input.value)}"]`
          );
          if (match instanceof HTMLInputElement && !match.checked) match.click();

          const selected = [...this.querySelectorAll('fieldset input:checked')].map((item) => item.value);
          const entry = this.data.find(
            (variant) =>
              variant.options.length === selected.length && variant.options.every((option, index) => option === selected[index])
          );
          const measurements = entry?.measurements;
          if (!measurements) return;

          for (const key of ['waist', 'hip', 'drop', 'inseam', 'leg_opening']) {
            const measure = this.querySelector(`[data-measure="${key}"]`);
            const value = measurements[key];
            if (!value) {
              measure?.setAttribute('hidden', '');
              continue;
            }
            measure?.removeAttribute('hidden');
            const label = this.querySelector(`[data-measurement="${key}"]`);
            if (label) label.textContent = value;
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
